import React from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { fmtRoDate, fmtRoDateTime } from "../../lib/dateFmt";

export function DetailsDialog({ kind, data, onClose }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const hideChf = user?.role === "planificator" || user?.role === "user";
  if (!data) return null;
  const isRegie = kind === "regie";
  const color = data.color || (isRegie ? "#F59E0B" : "#3B82F6");

  const Field = ({ label, value, mono }) => (value === null || value === undefined || value === "" ? null : (
    <div className="grid grid-cols-3 gap-2 text-sm border-b border-[var(--border)] py-1.5">
      <div className="text-zinc-500 text-xs uppercase tracking-wider">{label}</div>
      <div className={`col-span-2 ${mono ? "font-mono" : ""} text-zinc-900`}>{value}</div>
    </div>
  ));

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl max-h-[85vh] overflow-y-auto" data-testid="details-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: color }}/>
            {isRegie ? "🛠 Regie" : "📁 Proiect"}: {data.name}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-1">
          {isRegie ? (
            <>
              <Field label="Firmă" value={data.firma}/>
              <Field label="Adresă" value={data.adresa}/>
              <Field label="Notă" value={data.note}/>
              <Field label="Status" value={data.active === false ? "🔴 Încheiată" : "🟢 Activă"}/>
              <Field label="Start" value={fmtRoDate(data.start_date)}/>
              <Field label="Sfârșit" value={data.indeterminate_end ? "♾ Nedeterminat" : fmtRoDate(data.end_date)}/>
              <Field label="Necesar persoane (default)" value={data.default_min_people ? `${data.default_min_people}` : null}/>
            </>
          ) : (
            <>
              <Field label="Status" value={data.status}/>
              <Field label="Categorie" value={data.category}/>
              <Field label="Adresă" value={data.adresa}/>
              <Field label="Auftraggeber" value={data.auftraggeber ? `${data.auftraggeber}${data.auftraggeber_phone ? ` · 📞 ${data.auftraggeber_phone}` : ""}` : null}/>
              <Field label="Bauherr" value={data.bauherr ? `${data.bauherr}${data.bauherr_phone ? ` · 📞 ${data.bauherr_phone}` : ""}` : null}/>
              <Field label="Bauleiter" value={data.bauleiter ? `${data.bauleiter}${data.bauleiter_phone ? ` · 📞 ${data.bauleiter_phone}` : ""}` : null}/>
              <Field label="Email contact" value={data.contact_email}/>
              <Field label="Start" value={fmtRoDate(data.start_date)}/>
              <Field label="Sfârșit" value={fmtRoDate(data.end_date)}/>
              <Field label="Necesar persoane" value={data.min_people ? `${data.min_people}` : null}/>
              <Field label="Descriere" value={data.description}/>
              <Field label="Special" value={data.special}/>
              <Field label="Preț ofertat" value={(!hideChf && data.oferta_price) ? `${data.oferta_price} CHF` : null}/>
              <Field label="Deadline ofertare" value={fmtRoDate(data.oferta_deadline)}/>
              <Field label="Ofertat la" value={fmtRoDate(data.ofertat_at)}/>
              <Field label="Răspuns ofertă" value={data.oferta_response === "accepted" ? "✓ Acceptat" : data.oferta_response === "refused" ? "✕ Refuzat" : null}/>
              <Field label="Anmelduit SUVA la" value={fmtRoDate(data.anmelduit_suva_at)}/>
              <Field label="Konzept printat la" value={data.konzept_printed_at ? fmtRoDateTime(data.konzept_printed_at) : null}/>
            </>
          )}
        </div>
        {data.documente?.length > 0 && (
          <div className="mt-3 pt-3 border-t border-[var(--border)]">
            <div className="text-xs uppercase tracking-wider text-zinc-500 mb-2">📎 Documente</div>
            <div className="flex flex-wrap gap-1.5">
              {data.documente.map((d) => (
                <a key={d.file_id} href={`${api.defaults.baseURL}/uploads/${d.file_id}`} target="_blank" rel="noreferrer" className="text-[11px] px-2 py-1 rounded bg-zinc-100 hover:bg-zinc-200 font-mono truncate max-w-[200px]">
                  {d.doc_type ? `[${d.doc_type}] ` : ""}{d.name || "fișier"}
                </a>
              ))}
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Închide</Button>
          <Button
            onClick={() => navigate(`/proiecte?${isRegie ? "regie" : "project"}=${data.id}`)}
            className="bg-[var(--primary)] hover:bg-[var(--primary-hover)]"
            data-testid="details-go-edit"
          >
            ✏️ Editează în Proiecte
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
